import type { ClassicCss, SelectorObj } from '../shared.types'
import { DEFAULT_DATA_MODE, HOVER_DATA_MODE } from '@wix/thunderbolt-commons'

const EMPTY_OBJECT = {}

const addPrefixToSelector = (selector: string, prefix: string) => {
	if (prefix) {
		const isRepeaterItemSelector = selector.startsWith('[id^="')
		if (isRepeaterItemSelector) {
			return selector.replace('[id^="', `[id^="${prefix}`)
		}
		return `#${prefix}${selector.substring(1)}`
	}
	return selector
}
export const fromClassicCss = (
	classic: ClassicCss['css'],
	compSelector: string,
	prefix: string = '',
	isHoverBox = false
) => {
	if (!classic) {
		return EMPTY_OBJECT
	}
	const {
		'': defaultCss = EMPTY_OBJECT,
		[HOVER_DATA_MODE]: hoverModeCss,
		[DEFAULT_DATA_MODE]: defaultOverrideCss,
	} = classic

	const caluclatedSelector = addPrefixToSelector(compSelector, prefix)
	const acc: SelectorObj = {
		[caluclatedSelector]: defaultCss,
	}
	const separator = isHoverBox ? '' : ' '
	if (hoverModeCss) {
		const { height: _ignored_1, width: _ignored_2, ...rest } = defaultCss
		acc[`${HOVER_DATA_MODE}${separator}${compSelector}`] = { ...rest, ...hoverModeCss }
	}
	if (defaultOverrideCss) {
		acc[`${DEFAULT_DATA_MODE}${separator}${compSelector}`] = defaultOverrideCss
	}

	return acc
}
